import { UseManageUnitDescriptionFormProps } from "./types";

export const floorOptions = [
  "Basement",
  "Ground",
  "1st",
  "2nd",
  "3rd",
  "4th",
  "5th",
  "6th",
  "7th",
  "8th",
  "9th",
  "10th",
  "11th",
  "12th",
  "13th",
  "14th",
  "15th",
];

export const fields: UseManageUnitDescriptionFormProps[] = [
  {
    id: "floor",
    name: "floor",
    label: "Floor 🏢",
    type: "select",
    options: floorOptions.map((f) => ({ label: f, value: f })),
  },
  {
    id: "description1",
    name: "description1",
    label: "Description 1 📝",
    type: "select",
    options: [
      { label: "Indoor", value: "Indoor" },
      { label: "Outdoor", value: "Outdoor" },
    ],
  },
  {
    id: "description2",
    name: "description2",
    label: "Description 2 📝",
    type: "select",
    options: [
      { label: "Elevator Access", value: "Elevator Access" },
      { label: "Ground Floor", value: "Ground Floor" },
      { label: "Drive-Up Access", value: "Drive-Up Access" },
    ],
  },
  {
    id: "description3",
    name: "description3",
    label: "Description 3 📝",
    type: "select",
    options: [
      { label: "Climate Controlled", value: "Climate Controlled" },
      { label: "24/7 Access", value: "24/7 Access" },
      { label: "Lighted Units", value: "Lighted Units" },
      { label: "High Ceilings", value: "High Ceilings" },
      { label: "Concrete Building", value: "Concrete Building" },
    ],
  },
  {
    id: "description4",
    name: "description4",
    label: "Description 4 📝",
    type: "select",
    options: [
      { label: "Climate Controlled", value: "Climate Controlled" },
      { label: "24/7 Access", value: "24/7 Access" },
      { label: "Lighted Units", value: "Lighted Units" },
      { label: "High Ceilings", value: "High Ceilings" },
      { label: "Concrete Building", value: "Concrete Building" },
    ],
  },
];

export const SIZE_FORM_SECTIONS = [
  {
    title: "Unit Details",
    keys: [
      "floor",
      "description1",
      "description2",
      "description3",
      "description4",
    ],
    colClass: "col-12 md:col-6 px-1",
  },
];

export const CreateFeatureInitialValues = {
  floor: "",
  description1: "",
  description2: "",
  description3: "",
  description4: "",
};
